import './eqs-form.scss';

import SlimSelect from 'slim-select';

class EQSFormField {
    constructor ($element, options) {
        const defaults = {
            filledClassname: 'form__input-is--filled',
            focusedClassname: 'form__input-is--focused',
            errorClassname: 'form__input-has--error'
        };

        this.settings = Object.assign({}, defaults, options);
        this.$formField = $element;

        this.initialize();
    }

    initialize () {
        this.initField(this.$formField);
    }

    initField ($element) {
        this.checkField($element);
        const formType = $element.tagName.toLowerCase(); // eslint-disable-line
        const $parent = $element.closest('.form__field');

        switch (formType) {
        case 'select': {
            $parent.classList.add('form__select');
            const $label = $parent.querySelector('label');

            let closeOnSelect = false;
            let allowDeselect = true;
            if ($element.getAttribute('multiple') === null) {
                closeOnSelect = true;
                allowDeselect = false;
            }

            $element.setAttribute('placeholder', $label.innerText);

            const fieldAPI = new SlimSelect({
                select: $element,
                settings: {
                    allowDeselect: allowDeselect,
                    closeOnSelect: closeOnSelect,
                    showSearch: false,
                    placeholderText: $element.getAttribute('placeholder')
                },
                events: {
                    beforeOpen: () => {
                        $parent.classList.add(this.settings.focusedClassname);
                    },
                    beforeClose: () => {
                        $parent.classList.remove(this.settings.focusedClassname);
                    }
                }
            });
            $element.fieldAPI = fieldAPI;

            break;
        }
        }

        $element.addEventListener('change', () => {
            $parent.classList.remove(this.settings.errorClassname);
            this.checkField($element);
        });

        $element.addEventListener('focus', () => {
            $parent.classList.remove(this.settings.errorClassname);
            $parent.classList.add(this.settings.focusedClassname);
        });

        $element.addEventListener('focusout', () => {
            $parent.classList.remove(this.settings.focusedClassname);
        });
    }

    checkField ($element) {
        const formType = $element.tagName.toLowerCase();
        const $parent = $element.closest('.form__field');

        switch (formType) {
        case 'select': {
            let filled = true;

            if ($element.value === 0 || $element.value === '0') {
                if ($parent.innerText === '') {
                    filled = false;
                }
            }

            if (filled === false) {
                $parent.classList.remove(this.settings.filledClassname);
            } else {
                $parent.classList.add(this.settings.filledClassname);
            }

            break;
        }
        case 'radio': {
            break;
        }
        case 'checkbox': {
            break;
        }

        default: {
            if ($element.value !== '' || formType === 'select') {
                $parent.classList.add(this.settings.filledClassname);
            } else {
                $parent.classList.remove(this.settings.filledClassname);
            }
        }
        }
    }
}

export { EQSFormField };

window.addEventListener('content.loaded', (e) => {
    const eventDetails = e.detail;
    const $context = eventDetails.$context;
    if ($context) {
        const eqsLoader = window.setInterval(() => {
            const $eqsApp = document.querySelector('.eqs-cms-irtool-app');
            if ($eqsApp) {
                clearInterval(eqsLoader);

                $eqsApp.classList.remove('svelte-gm53dl');

                const $$eqsFields = $context.querySelectorAll('[slot="field"]');
                for (let i = 0; i < $$eqsFields.length; i++) {
                    const $eqsField = $$eqsFields[i];

                    if ($eqsField) {
                        const $parent = $eqsField.closest('div');
                        if ($parent) {
                            $parent.classList.add('form__field');

                            const $label = $parent.querySelector('label');
                            if ($label) {
                                $label.classList.add('form__label');
                            }
                        }

                        $eqsField.API = new EQSFormField($eqsField);
                    }
                }

                const $button = $eqsApp.querySelector('button[type="submit"]');
                if ($button) {
                    $button.classList.add('button');
                    $button.classList.add('button--highlight');
                    $button.innerHTML = '<span>' + $button.innerText + '</span>';
                }

                const $checkboxes = $eqsApp.querySelectorAll('.checkbox');
                for (let i = 0; i < $checkboxes.length; i++) {
                    const $checkbox = $checkboxes[i];

                    const $label = $checkbox.querySelector('label');
                    const $input = $checkbox.querySelector('[type="checkbox"]');
                    if ($input && $label) {
                        $checkbox.insertBefore($input, $label);

                        $label.classList.add('form__label');
                        $label.classList.add('form__label--checkbox');
                    }

                    $checkbox.classList.add('form__field');
                    $checkbox.classList.add('form__input-is--checkbox');
                }
            }
        }, 500);
    }
});
